import { Pipe, PipeTransform } from '@angular/core';
import { formatPrice } from '@hyundai/shared-lib';

@Pipe({
    standalone: true,
    name: 'formatPrice',
})
export class FormatPricePipe implements PipeTransform {
    transform(price: string): string {
        return formatPrice(price);
    }
}
